import { render, staticRenderFns } from "./plan-list.vue?vue&type=template&id=c70cb4c4&scoped=true&"
import script from "./plan-list.vue?vue&type=script&lang=js&"
export * from "./plan-list.vue?vue&type=script&lang=js&"
import style0 from "./plan-list.vue?vue&type=style&index=0&id=c70cb4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70cb4c4",
  null
  
)

export default component.exports